import { useParams, useRouter } from "@tanstack/react-router";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { SidebarItemButton } from "@/components/catalyst/sidebar";

/**
 * Lets an actual admin flip between the `/admin` and `/org` tenant prefixes for
 * the current org — `/org` is the "view as tenant" mode. The prefix is the
 * source of truth for admin-ness, so this just rewrites the first path segment.
 */
export function TenantViewToggle() {
  const router = useRouter();
  const { tenant } = useParams({ strict: false }) as { tenant?: string };
  const { isActuallyAdmin } = useTenant();

  if (!isActuallyAdmin) {
    return null;
  }

  const isTenantView = tenant === "org";

  function toggleTenant() {
    const nextTenant = isTenantView ? "admin" : "org";
    const pathname = router.state.location.pathname.replace(
      /^\/[^/]+/,
      `/${nextTenant}`,
    );
    router.navigate({ to: pathname, search: (prev) => prev });
  }

  return (
    <SidebarItemButton onClick={toggleTenant}>
      <span
        className={`truncate text-xs ${isTenantView ? "text-amber-400" : "text-zinc-400"}`}
      >
        {isTenantView ? "Tenant View" : "Admin View"}
      </span>
      {isTenantView ? (
        <EyeSlashIcon className="ml-auto h-4 w-4 text-amber-400" />
      ) : (
        <EyeIcon className="ml-auto h-4 w-4 text-zinc-400" />
      )}
    </SidebarItemButton>
  );
}
